/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: timers.ts
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  30.09.22 2:29 pm.
 * Last modified: 30.09.22 2:29 pm.
 *
 * More information at: https://egt-digital.com/
 */

const timers: {
    JP_STAT_FETCH: ReturnType<typeof setInterval> | null;
    JP_STAT_UPDATE: ReturnType<typeof setInterval> | null;
    GAMES_CURRENT_PLAYERS_FETCH: ReturnType<typeof setInterval> | null;
} = {
    JP_STAT_FETCH: null,
    JP_STAT_UPDATE: null,
    GAMES_CURRENT_PLAYERS_FETCH: null,
};

export const clearTimer = (timer: ReturnType<typeof setInterval> | null) => {
    if (timer) {
        clearInterval(timer);
        timer = null;
    }
};

export default timers;
